import {
  AppstoreOutlined,
  ShopOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { AdminLayout } from "layouts/AdminLayout";
import React from "react";
import { NotFoundPage } from "views/404/NotFoundPage";
import { AccountPage } from "views/Account/AccountPage";
import LoginPage from "views/Login/LoginPage";
import { ProductPage } from "views/Product/ProductPage";
import { ProductCategoryPage } from "views/ProductCategory/ProductCategoryPage";
import { ShopPage } from "views/Shop/ShopPage";

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  name?: string;
  title?: string;
  children?: AppRoute[];
  icon?: React.ReactNode;
  breadcrumb?: string;
  isAccess?: boolean;
  hidden?: boolean;
  checkIsDev?: boolean;
}

export type Route = AppRoute;

export const adminRoutes: AppRoute[] = [
  {
    title: "Sản phẩm",
    icon: <AppstoreOutlined />,
    path: "/product",
    breadcrumb: "Sản phẩm",
    element: <ProductPage title="Sản phẩm" />,
  },
  {
    title: "Danh mục sản phẩm",
    icon: <AppstoreOutlined />,
    path: "/product-category",
    breadcrumb: "Danh mục sản phẩm",
    element: <ProductCategoryPage title="Danh mục sản phẩm" />,
  },

  {
    title: "Doanh nghiệp",
    icon: <ShopOutlined />,
    path: "/shop",
    breadcrumb: "Doanh nghiệp",
    element: <ShopPage title="Doanh nghiệp" />,
  },
  {
    title: "Tài khoản",
    icon: <UserOutlined />,
    path: "/profile",
    breadcrumb: "Tài khoản",
    element: <AccountPage title="Tài khoản" />,
  },
];

const routes: AppRoute[] = [
  {
    path: "/",
    element: <AdminLayout />,
    children: adminRoutes,
  },
  {
    path: "/login",
    element: <LoginPage title="Đăng nhập" />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export { routes };
